// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner_sliderContainer__9a0Sh {
    width: 'boxed';
    max-width: 1000px; /* Ensuring max width is 1200px */
    margin: auto;
    height: auto; /* Setting height of slider */
    overflow: hidden;
    margin-top: 50px;
    margin-bottom: 50px;
    border-radius: 10px; /* Optional rounded corners */
  }
  
  .Banner_slide__MkOzP {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .Banner_image__KXGTH {
    max-width: 1200px; /* Ensuring image max width */
    width: 100%;
    height: auto;
    border-radius: 10px; /* Optional rounded corners */
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2); /* Optional shadow */
  }
`, "",{"version":3,"sources":["webpack://./src/AudioPage/components/Css/Banner.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB,EAAE,iCAAiC;IACpD,YAAY;IACZ,YAAY,EAAE,6BAA6B;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB,EAAE,6BAA6B;EACpD;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB,EAAE,6BAA6B;IAChD,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAE,6BAA6B;IAClD,2CAA2C,EAAE,oBAAoB;EACnE","sourcesContent":[".sliderContainer {\n    width: 'boxed';\n    max-width: 1000px; /* Ensuring max width is 1200px */\n    margin: auto;\n    height: auto; /* Setting height of slider */\n    overflow: hidden;\n    margin-top: 50px;\n    margin-bottom: 50px;\n    border-radius: 10px; /* Optional rounded corners */\n  }\n  \n  .slide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .image {\n    max-width: 1200px; /* Ensuring image max width */\n    width: 100%;\n    height: auto;\n    border-radius: 10px; /* Optional rounded corners */\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2); /* Optional shadow */\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sliderContainer": `Banner_sliderContainer__9a0Sh`,
	"slide": `Banner_slide__MkOzP`,
	"image": `Banner_image__KXGTH`
};
export default ___CSS_LOADER_EXPORT___;
